<template>
  <div class="g6-component-contextmenu" ref="g6_component_contextmenu">
        <ul>
            <li title="delete" @click="cellDelete">删除</li>
            <li title="front" @click="cellFront">置于顶层</li>
            <li title="back" @click="cellBack">置于底层</li>
        </ul>
    </div>
</template>

<script>
import insertCss from 'insert-css'

//node右键菜单样式
insertCss(`
      .g6-component-contextmenu {
        position: absolute;
        list-style-type: none;
        padding: 10px 8px;
        left: -150px;
        background-color: #f1f3f4;;
        border: 1px solid #e2e2e2;
        border-radius: 4px;
        font-size: 12px;
        color: #545454;
      }
      .g6-component-contextmenu ul {
        display: block;
        list-style-type: disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 0px;
        margin:0px;
    }
      .g6-component-contextmenu li {
        cursor: pointer;
        list-style-type:none;
        list-style: none;
        margin-left: 0px;
        line-height: 25px;
      }
     .g6-component-contextmenu li:hover {
        color: #aaa;
      }

      .g6-component-toolbar {
        right: 10px;
        bottom: 10px;
        left: unset;
        top: unset;
        }
    `);


export default {
  name: "NodeMenu",
  props: {
    contextmenuCell: {},
    checkLogin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    //显示节点菜单
    showNodeMenu(realPosition, width) {
      this.$refs.g6_component_contextmenu.style.top = (realPosition.y + 5) + 'px';
      this.$refs.g6_component_contextmenu.style.left = (realPosition.x + width - 5) + 'px';
    },
    //隐藏节点菜单
    hideNodeMenu() {
      this.$refs.g6_component_contextmenu.style.left = '-150px';
    },
    //删除
    cellDelete: function () {
        this.$parent.graph.removeCell(this.contextmenuCell)
        this.$parent.emitDeleteNode(this.$parent.nodeToInfo(this.contextmenuCell))
    },
    //置于顶层
    cellFront: function () {
      let zIndex1 = this.contextmenuCell.zIndex
      this.contextmenuCell.toFront()
      let zIndex2 = this.contextmenuCell.zIndex
      if (zIndex1 !== zIndex2) {
        this.$parent.emitUpdateNode(this.$parent.nodeToInfo(this.contextmenuCell))
      } else {
        this.hideNodeMenu()
      }
    },
    //置于底层
    cellBack: function () {
      let zIndex1 = this.contextmenuCell.zIndex
      this.contextmenuCell.toBack()
      let zIndex2 = this.contextmenuCell.zIndex
      if (zIndex1 !== zIndex2) {
        this.$parent.emitUpdateNode(this.$parent.nodeToInfo(this.contextmenuCell))
      } else {
        this.hideNodeMenu()
      }
    },
  }
}
</script>

<style>
</style>
